import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./profile.css";
import { CSSTransition } from "react-transition-group";
import { Chart } from "chart.js";
import { useNavigate } from "react-router-dom";
import { BOARD_OPTIONS } from "../../utils/subjectBoard";
import {
  editProfile,
  profileCompletionPercentage,
  profileDetails,
} from "../../Redux/profile/profile.action";
import DoughnutChart from "../../Users/components/test/DoughnutChart";
import Loader from "../../utils/loader/loader";
import ToastMessage from "../../utils/toasts/toastMessage";

const AdminProfileBody = () => {
  const dispatch = useDispatch();
  const nav = useNavigate();
  const store = useSelector((state) => state);
  const [loading, setLoading] = useState(false);
  const [toastState, setToastState] = useState({
    show: false,
    message: "",
    type: "",
  });

  const [showCloseBtn, setShowCloseBtn] = useState(false);

  const adminDetails = useSelector(
    (state) => state?.ProfileManager?.user_details,
  );
  const profile_completion = useSelector(
    (state) => state?.ProfileManager?.completion?.profile_completion,
  );

  useEffect(() => {
    if (profile_completion < 40) {
      setIsEditable(true);
    } else {
      setIsEditable(false);
    }
  }, [profile_completion]);

  useEffect(() => {
    if (!profile_completion) {
      setLoading(true);
    } else setLoading(false);
  }, [profile_completion]);

  const [isEditable, setIsEditable] = useState(false);
  const [fields, setFields] = useState({
    school: adminDetails?.school || "",
    board: adminDetails?.board || "",
    city: adminDetails?.address || "",
    country: adminDetails?.country || "India",
    employee_id: adminDetails?.employee_id || "",
    phone: adminDetails?.phone_number || "",
  });

  const [missingFields, setMissingFields] = useState({});

  useEffect(() => {
    dispatch(profileDetails());
    dispatch(profileCompletionPercentage());
  }, [dispatch]);

  useEffect(() => {
    if (!adminDetails) return;

    setFields({
      school: adminDetails?.school || "",
      board: adminDetails?.board || "",
      city: adminDetails?.address || "",
      country: adminDetails?.country || "",
      employee_id: adminDetails?.employee_id || "",
      phone: adminDetails?.phone_number || "",
    });
  }, [adminDetails]);

  // Load user details into fields when switching to edit mode
  const handleEdit = () => {
    setShowCloseBtn(true);
    setFields({
      school: adminDetails?.school || "",
      board: adminDetails?.board || "",
      city: adminDetails?.address || "",
      country: adminDetails?.country || "",
      employee_id: adminDetails?.employee_id || "",
      phone: adminDetails?.phone_number || "",
    });
    setIsEditable(true);
  };

  const handleCloseBtn = () => {
    setShowCloseBtn(false);
    setIsEditable(false);
  };

  // const handleInputChange = (e) => {
  //   const { name, value } = e.target;
  //   setFields({
  //     ...fields,
  //     [name]: value,
  //   });
  // };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFields({
      ...fields,
      [name]: value,
    });
    if (missingFields[name])
      setMissingFields((prev) => ({ ...prev, [name]: false }));
  };

  const handleApply = async (e) => {
    e.preventDefault();
    setLoading(true);

    const requiredFields = [
      "school",
      "city",
      "country",
      "employee_id",
      "phone",
    ];

    const emptyFields = requiredFields.reduce((acc, field) => {
      if (!fields[field]) acc[field] = true;
      return acc;
    }, {});

    if (Object.keys(emptyFields).length > 0) {
      const missingFieldNames = Object.keys(emptyFields)
        .map((field) => field.replace("_", " "))
        .join(", ");

      setToastState({
        show: true,
        message: `Please fill the mandatory field: ${missingFieldNames}`,
        type: "error",
      });

      setMissingFields(emptyFields);
      setLoading(false);
      return;
    }

    if (fields.phone && !/^[6-9]\d{9}$/.test(fields.phone.trim())) {
      setToastState({
        show: true,
        message: "Please enter a valid 10-digit Indian phone number.",
        type: "error",
      });
      setMissingFields((prev) => ({ ...prev, phone: true }));
      setLoading(false);
      return;
    }

    setMissingFields({});

    const payload = {
      school: fields.school,
      address: fields.city,
      country: fields.country,
      employee_id: fields.employee_id,
      phone_number: fields.phone,
    };

    const result = await dispatch(editProfile(payload));

    if (result.success) {
      setToastState({
        show: true,
        message: "Profile updated successfully.",
        type: "success",
      });

      // onProfileUpdateSuccess();
      dispatch(profileCompletionPercentage());
      setTimeout(() => {
        nav("/people");
      }, 1000);
    } else {
      setToastState({
        show: true,
        message: result.message || "Something went wrong! Try again.",
        type: "error",
      });
    }

    setLoading(false);
    setIsEditable(false);
  };

  return (
    <div className="profile">
      <div className="profile__info">
        <div className="info-left">
          <div className="bdrs40 blue-block">
            <div className="w-100 title-bar">
              <div className="title-bar__left">
                <img
                  src="./assets/images/inner-pages/icons/icon-nav-user.svg"
                  alt=""
                />
                <div className="name">
                  <h2 className="text-capitalize mb-1 fw700 fz36">
                    {adminDetails?.first_name} {adminDetails?.last_name}
                  </h2>
                  {/* <p className="m-0">Your Recent Works</p> */}
                </div>
              </div>
              {showCloseBtn ? (
                <button
                  className="btn btn-solid btn-solid--dark"
                  onClick={handleCloseBtn}
                >
                  <span className="fw500 fz16 text-nowrap">Close</span>
                </button>
              ) : (
                <button
                  className="btn btn-solid btn-solid--dark"
                  onClick={handleEdit}
                >
                  <span className="fw500 fz16 text-nowrap">
                    {isEditable ? "Complete Your Profile" : "Edit profile"}
                  </span>
                </button>
              )}
            </div>
            <hr className="sep" />
            <h4 className="lh1 fz24 fw700">Personal info</h4>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr 1fr",
                gap: "12px",
                marginBottom: "12px",
              }}
            >
              {/* Employee ID */}
              <div
                style={{ display: "flex", flexDirection: "column", gap: "4px" }}
              >
                <label className="fz14 fw500">
                  Employee ID{" "}
                  <span className={isEditable ? "error-mandate" : ""}>*</span>
                </label>
                <input
                  type="text"
                  className={`fz14 form-control ${missingFields.employee_id ? "is-invalid" : ""}`}
                  name="employee_id"
                  readOnly={!isEditable}
                  value={fields?.employee_id}
                  onChange={handleInputChange}
                  style={{ padding: "6px 10px", height: "36px" }}
                />
              </div>

              {/* School/Institute */}
              <div
                style={{ display: "flex", flexDirection: "column", gap: "4px" }}
              >
                <label className="fz14 fw500" style={{ color: "inherit" }}>
                  School/Institute{" "}
                  <span className={isEditable ? "error-mandate" : ""}>*</span>
                </label>
                <input
                  type="text"
                  className={`fz14 form-control ${missingFields.school ? "is-invalid" : ""}`}
                  name="school"
                  readOnly={!isEditable}
                  value={fields?.school}
                  onChange={handleInputChange}
                  style={{ padding: "6px 10px", height: "36px" }}
                />
              </div>

              {/* City */}
              <div
                style={{ display: "flex", flexDirection: "column", gap: "4px" }}
              >
                <label className="fz14 fw500">
                  City{" "}
                  <span className={isEditable ? "error-mandate" : ""}>*</span>
                </label>
                <input
                  type="text"
                  className={`fz14 form-control ${missingFields.city ? "is-invalid" : ""}`}
                  name="city"
                  readOnly={!isEditable}
                  value={fields?.city}
                  onChange={handleInputChange}
                  style={{ padding: "6px 10px", height: "36px" }}
                />
              </div>
            </div>

            {/* ── ROW 2: Emp ID | Country | Phone | Email ── */}
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr 1fr",
                gap: "12px",
                marginBottom: "20px",
              }}
            >
              {/* Country */}
              <div
                style={{ display: "flex", flexDirection: "column", gap: "4px" }}
              >
                <label className="fz14 fw500">
                  Country{" "}
                  <span className={isEditable ? "error-mandate" : ""}>*</span>
                </label>
                <input
                  type="text"
                  className={`fz14 form-control ${missingFields.country ? "is-invalid" : ""}`}
                  name="country"
                  readOnly={!isEditable}
                  value={fields?.country}
                  onChange={handleInputChange}
                  style={{ padding: "6px 10px", height: "36px" }}
                />
              </div>

              {/* Phone */}
              <div
                style={{ display: "flex", flexDirection: "column", gap: "4px" }}
              >
                <label className="fz14 fw500">
                  Phone Number{" "}
                  <span className={isEditable ? "error-mandate" : ""}>*</span>
                </label>
                <input
                  type="text"
                  className={`fz14 form-control ${missingFields.phone ? "is-invalid" : ""}`}
                  name="phone"
                  readOnly={!isEditable}
                  value={fields?.phone}
                  onChange={handleInputChange}
                  style={{ padding: "6px 10px", height: "36px" }}
                />
              </div>

              {/* Email */}
              <div
                style={{ display: "flex", flexDirection: "column", gap: "4px" }}
              >
                <label className="fz14 fw500">Email</label>
                <input
                  type="email"
                  required
                  disabled
                  className="fz14 form-control"
                  name="email"
                  value={adminDetails?.email}
                  style={{ padding: "6px 10px", height: "36px" }}
                />
              </div>
            </div>
            {showCloseBtn && (
              <>
                <span className="fz18">
                  <span className="error-mandate">* </span> mandatory fields
                </span>
                <button
                  className="btn btn-solid btn-solid--dark btn-apply"
                  type="submit"
                  onClick={(e) => handleApply(e)}
                >
                  Apply
                </button>
              </>
            )}
          </div>
        </div>
        <div className="info-right">
          <div className="bdrs40 checklist-content">
            <div className="text-center">
              <h3 className="fw700 fz28 text-white  show-above-768 hide-below-768">
                Complete your profile
              </h3>
            </div>
            <div className="success-chart">
              <DoughnutChart
                elementId="profileSuccessDonut"
                color="#32FB6F"
                dataValue={profile_completion || 0}
                graphBorder="78%"
              />
              <div className="fw700 text-white fz44 inner-num">
                {profile_completion || 0}%
              </div>
            </div>
            <ul className="list-inline checklist">
              <li>
                <div className="ps-1 fw500 fz20 checkbox-container">
                  <input
                    id="cklt-06"
                    type="checkbox"
                    name="cklt"
                    className="cklt-input cklt-toggle"
                    checked={
                      !!(
                        adminDetails?.employee_id &&
                        adminDetails?.employee_id !== "NA"
                      )
                    }
                  />
                  <label htmlFor="cklt-06">
                    <b />
                    <span className="ps-1">Employee_ID</span>
                  </label>
                </div>
              </li>

              <li>
                <div className="ps-1 fw500 fz20 checkbox-container">
                  <input
                    id="cklt-06"
                    type="checkbox"
                    name="cklt"
                    className="cklt-input cklt-toggle"
                    checked={
                      !!(adminDetails?.email && adminDetails?.email !== "NA")
                    }
                  />
                  <label htmlFor="cklt-06">
                    <b />
                    <span className="ps-1">Email</span>
                  </label>
                </div>
              </li>

              <li>
                <div className="ps-1 fw500 fz20 checkbox-container">
                  <input
                    id="cklt-02"
                    type="checkbox"
                    name="cklt"
                    className="cklt-input cklt-toggle"
                    checked={
                      !!(adminDetails?.school && adminDetails?.school !== "NA")
                    }
                    readOnly
                  />
                  <label htmlFor="cklt-02">
                    <b />
                    <span className="ps-1">School/Institute</span>
                  </label>
                </div>
              </li>
              <li>
                <div className="ps-1 fw500 fz20 checkbox-container">
                  <input
                    id="cklt-03"
                    type="checkbox"
                    name="cklt"
                    className="cklt-input cklt-toggle"
                    checked={
                      !!(
                        adminDetails?.address && adminDetails?.address !== "NA"
                      )
                    }
                    readOnly
                  />
                  <label htmlFor="cklt-03">
                    <b />
                    <span className="ps-1">City</span>
                  </label>
                </div>
              </li>
              <li>
                <div className="ps-1 fw500 fz20 checkbox-container">
                  <input
                    id="cklt-04"
                    type="checkbox"
                    name="cklt"
                    className="cklt-input cklt-toggle"
                    checked={
                      !!(
                        adminDetails?.phone_number &&
                        adminDetails?.phone_number !== "NA"
                      )
                    }
                    readOnly
                  />
                  <label htmlFor="cklt-04">
                    <b />
                    <span className="ps-1">Phone</span>
                  </label>
                </div>
              </li>

              <li>
                <div className="ps-1 fw500 fz20 checkbox-container">
                  <input
                    id="cklt-05"
                    type="checkbox"
                    name="cklt"
                    className="cklt-input cklt-toggle"
                    checked={
                      !!(
                        adminDetails?.country && adminDetails?.country !== "NA"
                      )
                    }
                    readOnly
                  />
                  <label htmlFor="cklt-05">
                    <b />
                    <span className="ps-1">Country</span>
                  </label>
                </div>
              </li>
            </ul>
            <div className="cover-btn">
              <h3 className="fw700 fz24 text-white show-below-768 hide-above-768">
                Complete your profile
              </h3>
              <button
                type="button"
                className="btn fw500 fz18 btn-solid btn-solid--white"
              >
                {profile_completion === 100 ? "Completed" : "Not completed"}
              </button>
            </div>
          </div>
        </div>
      </div>
      <Loader show={loading} />
      <ToastMessage
        show={toastState.show}
        onClose={() => setToastState({ show: false, message: "", type: "" })}
        message={toastState.message}
        type={toastState.type}
      />
    </div>
  );
};

export default AdminProfileBody;
